/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback } from 'react';
import Switch from 'antd/lib/switch';
import type { SwitchChangeEventHandler } from 'antd/es/switch';
import styles from './KemuSwitch.module.css';

interface Props {
	onChange?: (checked: boolean, event: React.MouseEvent, data: any) => void;
	size: 'small' | 'default';
	checked: boolean;
	className?: string;
	'data-kemu-meta'?: string;
	data?: any;
	disabled?: boolean;
	style?: React.CSSProperties;
}

const KemuSwitch = (props: Props): React.JSX.Element => {
	const { data, onChange } = props;

	const handleChange: SwitchChangeEventHandler = useCallback((checked, event) => {
		if (onChange) {
			onChange(checked, event as React.MouseEvent, data);
		}
	}, [onChange, data]);

	return (
		<Switch
			{...props['data-kemu-meta'] ? { ['data-kemu-meta']: props['data-kemu-meta'] } : undefined }
			size={props.size || 'default'}
			checked={props.checked}
			onChange={handleChange}
			disabled={props.disabled}
			className={`${styles.KemuSwitch} ${props.className || ''}`}
			style={props.style}
		/>
	);
};

export default KemuSwitch;
